import React, {
  Children,
  Component,
  createContext,
  useContext,
  useState,
  useMemo,
  useEffect,
} from "react";
import { injectIntl } from "react-intl";
import axios from "axios";
import ToggleVisibility from "../components/features/ToggleVisibility";
import Modal from "../components/modals/Modal";
import ModalPortal from "../components/modals/ModalPortal";
import CookiePopup from '../components/popups/CookiePopup'
import ErrorHOC from "../hoc/ErrorHOC";

// REDUX
import { useDispatch } from "react-redux";

// import { clearEntrySteps, clearEntryStepActive } from '../actions/entryActions';

// COMPONENTS
// import MainHeaderNav from '../components/navigations/MainHeaderNav';
// import MainBoxNav from '../components/navigations/MainBoxNav';
// import FooterMain from '../components/footers/FooterMain';
import TogglePrompt from "../components/prompt/TogglePrompt";
import ReviewForm from "../components/forms/ReviewForm";
import NewButton from "../components/buttons/NewButton";
import Icon from "../components/icons/Icon";
// import ContentContainer from "../components/layout/ContentContainer";

const Testing = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [loader, setLoader] = useState();
  const MyContext = React.createContext();
  const dispatch = useDispatch();

  useEffect(() => {
    //setCounter(true);
  }, []);

  const showModal = () => {
    setIsVisible(!isVisible);
  };

  const cancel = () => {
    setIsVisible(false);
  };

  const loading = () => {
    setLoader(true);

    setTimeout(() => {
      setLoader(false);
      setIsVisible(false);
    }, 2000);
  };

  const test = (e) => {
    console.log('e', e)

  }

  return (
    <div className="App" style={{width: '500px', padding: '3rem'}}>



      {/* <TogglePrompt

        msg={['msg a', 'msg b']}
        btnText={['btn 1', 'btn 2']}
        view={false}
        callback={false}
      /> */}

      {/* <button data-focusid="42" onClick={showModal}>
        Show Modal
      </button> */}

      {/* <ModalPortal>
        <Modal
          oldTemplateDesign
          visible={isVisible}
          focusedElBeforeModalID="42"
          buttons={[
            { id: 1, value: "Yes", onClick: loading },
            { id: 2, value: "No", onClick: cancel },
          ]}
          closeModal={cancel}
          // loader={loader}
          title="Nullam volutpat fringilla"
          text="Aenean at felis ut arcu tempus pellentesque. Vivamus erat lacus, rutrum vel sodales ac, tincidunt vitae quam."
        />
      </ModalPortal> */}
    </div>
  );

  return (
    <div id="page">
      <div className="rowCon rowCon__withMargin">
        <div className="dashboardMain">
          {/* <MyContext.Provider value={counterGetSet}>s</MyContext.Provider> */}
        </div>
      </div>
    </div>
  );
};

export default Testing;
